import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  title: 'Geschätzte {{orderMethod}}: {{day}} gegen {{time}}',
  status: {
    [ORDER_FULFILLMENT_STATUSES.REJECTED]: {
      title: 'Bestellung storniert',
    },
    [ORDER_FULFILLMENT_STATUSES.CREATED]: {
      title: 'Bestellung erhalten',
    },
    [ORDER_FULFILLMENT_STATUSES.REVIEWED]: {
      title: 'Deine Bestellung wurde gesehen',
    },
    [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: {
      title: 'Bestellung bestätigt',
    },
    [ORDER_FULFILLMENT_STATUSES.READY]: {
      title: 'Bestellung ist fertig',
    },
    [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: {
      title: 'Bestellung wird geliefert',
    },
    [ORDER_FULFILLMENT_STATUSES.PICKED]: {
      title: 'Bestellung ist abgeschlossen',
    },
  },
  labels: {
    today: 'Heute',
  },
  waiting_confirmation: {
    title: 'Warten auf Bestellbestätigung',
    description: 'Einen Moment...',
  },
  pickup_time: {
    title: 'Abholzeit',
    description: 'Bestätigt von {{name}}',
  },
  delivery_time: {
    title: 'Lieferzeit',
    description: 'Bestätigt von {{name}}',
  },
  warning_label: {
    pickup_time_changed: '{{company}} änderte die Zeit von {{initialTime}} auf {{currentTime}}',
  },
};
